import {useTranslation} from 'next-i18next';
import {useMemo} from 'react';

import getRootServerUrl from '@/src/app/utils/getRootServerUrl';
import useIsMobile from '@/src/hooks/useIsMobile';
import {ClinicCertificateBrandingLayoutProps} from '@/src/profile/accountSettings/components/types/ClinicCertificateBrandingLayoutTypes';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, PageTitle, Text} from '@/src/ui';

import css from '../styles/ClinicCertificateBrandingLayout.module.css';

export const TEST_IDS = {
  SIGNATURE_IMAGE: 'signatureImage',
};

const ClinicCertificateBrandingLayout = ({
  onChangeLogoClick,
  signature,
}: ClinicCertificateBrandingLayoutProps): JSX.Element => {
  const {t} = useTranslation(TextLocal.LOCALE_SOURCE.COMMON);
  const {isMaxWidth900} = useIsMobile();
  const logoNode = useMemo(() => {
    return (
      <div className={css.logoBlock} data-testid={TEST_IDS.SIGNATURE_IMAGE}>
        <div className={css.logoBorder} />
        <div className={css.clinicLogo}>
          <img
            src={`${getRootServerUrl()}${signature}`}
            loading="lazy"
            alt={'Clinic logo'}
          />
        </div>
      </div>
    );
  }, [signature]);

  return (
    <div className={css.widget}>
      <PageTitle
        offset={PageTitle.BOTTOM_OFFSET.OFFSET_15}
        title={t('profile.certificate-branding')}
      />
      <div className={css.content}>
        <div className={css.leftContent}>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={Text.FONT_WEIGHT.BOLD}
            color={Text.COLOR.PRIMARY}
          >
            <TextLocal id={'profile.upload-clinic-logo'} />
          </Text>
          <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_14}>
            <TextLocal id={'profile.upload-clinic-logo-description'} />
          </Text>
          {Boolean(signature) && !isMaxWidth900 && logoNode}
        </div>
        <div className={css.rightContent}>
          <Button
            color={Button.COLOR.SECONDARY}
            height={Button.HEIGHT.SMALL}
            onClick={onChangeLogoClick}
            border={Button.BORDER.BOLD}
          >
            <TextLocal
              id={signature ? 'signature.change' : 'profile.add-logo'}
            />
          </Button>
        </div>
        {Boolean(signature) && isMaxWidth900 && logoNode}
      </div>
    </div>
  );
};

export default ClinicCertificateBrandingLayout;
